import Vue from 'vue';
import VueRouter from 'vue-router';
import { UserLayout, MainLayout } from '../layouts/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: '/home',
    invisible: true,
    meta: {
      icon: 'home',
      title: '首页',
    },
  },
  {
    path: '/home',
    component: MainLayout,
    redirect: '/home/dashbord',
    meta: {
      icon: 'home',
      title: '首页',
    },
    children: [
      {
        path: '/home/dashbord',
        name: 'dashbord',
        meta: {
          title: '控制面板',
          desc: '控制面板,控制面板',
          showHeader: true,
          icon: 'none',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/home/home.vue'),
      },
      {
        path: '/home/analysis',
        name: 'analysis',
        meta: {
          title: '单站数据',
          desc: '单站数据分析',
          showHeader: true,
          icon: 'none',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/home/analysis.vue'),
      },
      {
        path: '/home/month-report',
        name: 'monthReport',
        meta: {
          title: '月报数据',
          desc: '月报数据分析',
          showHeader: true,
          icon: 'none',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/home/monthReport.vue'),
      },
      {
        path: '/home/hot-port',
        name: 'hotPort',
        meta: {
          title: '热点数据',
          desc: '热点数据',
          showHeader: true,
          icon: 'none',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/home/hotPort.vue'),
      },
      {
        path: '/home/cab-usage',
        name: 'cabUse',
        meta: {
          title: '格子统计',
          desc: '格子使用统计',
          showHeader: true,
          icon: 'none',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/home/cabUse.vue'),
      },
      {
        path: '/company/recharge/:id',
        name: 'companyrecharge',
        invisible: true,
        meta: {
          icon: 'none',
          title: '公司充值',
          type: 'recharge',
          permissionKey: 'companyRecharge',
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/company/recharge.vue'),
      },
    ],
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    invisible: true,
    children: [
      {
        path: '/user/login',
        name: 'login',
        invisible: true,
        component: () => import(/* webpackChunkName: "login" */ '../views/user/Login.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
export default router;
